import { useQuery } from "@tanstack/react-query";
import { api, endpoints } from "../lib/api";
import Topbar from "../components/Topbar";
import { euro, shortDate } from "../lib/format";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Sales() {
  const { data: payments = [] } = useQuery({ queryKey: ["payments"], queryFn: () => api.get(endpoints.payments).then((r) => r.data) });

  const paid = payments.filter((p) => p.status === "pagado");
  const pending = payments.filter((p) => p.status !== "pagado");
  const total = paid.reduce((s, p) => s + p.amount, 0);
  const service = paid.filter((p) => p.kind === "service").reduce((s, p) => s + p.amount, 0);
  const membership = paid.filter((p) => p.kind === "membership").reduce((s, p) => s + p.amount, 0);
  const ticket = paid.length ? total / paid.length : 0;

  return (
    <div>
      <Topbar
        title="Ventas y facturación"
        subtitle="Registro de pagos, ticket medio y desglose por servicio y membresía."
        actions={
          <Button
            data-testid="sales-export"
            className="laka-btn-primary h-10 px-5 rounded-md"
            onClick={() => toast.success("Exportación simulada — CSV listo para descarga")}
          >
            <Download size={14} strokeWidth={1.5} className="mr-2" />
            Exportar datos
          </Button>
        }
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Stat eyebrow="Total facturado" value={euro(total)} />
        <Stat eyebrow="Ticket medio" value={euro(ticket)} />
        <Stat eyebrow="Servicios" value={euro(service)} />
        <Stat eyebrow="Membresías" value={euro(membership)} />
      </div>

      <div className="laka-card overflow-hidden" data-testid="sales-table">
        <table className="w-full">
          <thead>
            <tr>
              {["Clienta", "Concepto", "Tipo", "Fecha", "Importe", "Estado"].map((h) => (
                <th key={h} className="px-6 py-4 text-left text-[10px] tracking-[0.18em] uppercase font-medium" style={{ color: "var(--laka-text)" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} className="border-t laka-hairline">
                <td className="px-6 py-4 text-sm font-medium">{p.client_name}</td>
                <td className="px-6 py-4 text-sm">{p.concept}</td>
                <td className="px-6 py-4 text-xs" style={{ color: "var(--laka-text)" }}>
                  {p.kind === "service" ? "Servicio" : "Membresía"}
                </td>
                <td className="px-6 py-4 text-sm">{shortDate(p.date)}</td>
                <td className="px-6 py-4 text-sm font-medium">{euro(p.amount)}</td>
                <td className="px-6 py-4">
                  <span
                    className={`inline-flex items-center rounded-full px-3 py-0.5 text-[11px] ${
                      p.status === "pagado" ? "bg-[#F5EFE7] text-[#1A1A1A]"
                      : p.status === "pendiente" ? "bg-[#E8DFD1] text-[#1A1A1A]"
                      : "bg-[#F8D7D7] text-[#8B1A1A]"
                    }`}
                  >
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
            {payments.length === 0 && (
              <tr><td colSpan={6} className="px-6 py-16 text-center text-sm" style={{ color: "var(--laka-text)" }}>Sin registros de pago aún.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {pending.length > 0 && (
        <div className="mt-6 laka-card p-6 border-l-4" style={{ borderLeftColor: "#D6B36A" }}>
          <span className="laka-eyebrow">Atención</span>
          <div className="text-sm mt-1">{pending.length} pagos con estado <span className="font-medium">pendiente</span> o vencido. Revisa el listado.</div>
        </div>
      )}
    </div>
  );
}

function Stat({ eyebrow, value }) {
  return (
    <div className="laka-card p-5">
      <div className="laka-eyebrow">{eyebrow}</div>
      <div className="font-display text-3xl mt-2 leading-none">{value}</div>
    </div>
  );
}
